/*
 * Full-width carousels.
 *
 * The Featured and product rows are stretched to the full width of the window
 * by CSS, so cards carry on off both edges instead of stopping at the centred
 * container. This script then shifts each row sideways by exactly one card, so
 * the SECOND card lines up with the section heading and the first hangs off to
 * the left.
 *
 * It uses Swiper's own slidesOffsetBefore rather than padding or a starting
 * slide index: padding would be undone by Swiper's transforms, and an initial
 * slide index is unreliable in loop mode, where Swiper renumbers the slides.
 *
 * Swiper measures its slides once when it starts, so every change here is
 * followed by update(), and the whole thing re-runs when the window resizes.
 *
 * Until someone moves a row, the cards sitting left of the heading line are
 * hidden, so the page opens with the row starting neatly on the heading and
 * no half card cut off at the edge. The first drag, swipe or arrow click fades
 * them in to fill the gap.
 */
(function () {
  'use strict';

  var SELECTOR = '.featured-blocks-slider, .buy-again-slider';
  var DESKTOP = '(min-width: 768px)';

  function offsetOne(el) {
    var swiper = el.swiper;
    if (!swiper || !swiper.slides || !swiper.slides.length) return;

    // On phones the rows stay inside the container as before.
    if (!window.matchMedia(DESKTOP).matches) {
      swiper.params.slidesOffsetBefore = 0;
      swiper.params.slidesOffsetAfter = 0;
      swiper.update();
      showAllCards(el, swiper);
      return;
    }

    // Where the section heading starts - the row should line up with that.
    var container = el.closest('.container');
    if (!container) return;
    var contentLeft = container.getBoundingClientRect().left;

    var gap = swiper.params.spaceBetween || 0;
    var slideWidth = swiper.slides[0].getBoundingClientRect().width;
    if (!slideWidth) return;

    // Pull the row left by whole cards until it actually reaches past the edge
    // of the screen, so a card still lands on the heading line. One card was
    // enough on a laptop, but on a wide screen the margin beside the content is
    // wider than a card, so shifting by one left the row sitting inside the
    // page instead of running off it.
    var step = slideWidth + gap;
    var cards = Math.ceil((contentLeft + 1) / step);
    swiper.params.slidesOffsetBefore = contentLeft - cards * step;
    // Matching space at the far end, so the last card finishes level with the
    // heading rather than against the edge of the screen.
    swiper.params.slidesOffsetAfter = contentLeft;

    swiper.update();
    hideLeftCards(el, swiper, contentLeft);
  }

  function setHidden(slide, hidden, instant) {
    // Cards hidden as the row first lays out vanish at once, so they never
    // flash up at the left edge and fade away.
    slide.style.transition = instant ? 'none' : 'opacity 0.4s ease';
    slide.style.opacity = hidden ? '0' : '';
    slide.style.pointerEvents = hidden ? 'none' : '';
  }

  function hideLeftCards(el, swiper, contentLeft) {
    if (el.dataset.bleedRevealed) return;

    swiper.slides.forEach(function (slide) {
      setHidden(slide, slide.getBoundingClientRect().right <= contentLeft + 1, true);
    });

    if (el.dataset.bleedWatching) return;
    el.dataset.bleedWatching = 'true';

    function reveal() {
      el.dataset.bleedRevealed = 'true';
      swiper.slides.forEach(function (slide) {
        setHidden(slide, false);
      });
      swiper.off('sliderFirstMove navigationNext navigationPrev', reveal);
    }

    // Only things a person does count. slideChange is no good here: in loop
    // mode Swiper fires it by itself while re-measuring the row.
    swiper.on('sliderFirstMove navigationNext navigationPrev', reveal);
  }

  function showAllCards(el, swiper) {
    swiper.slides.forEach(function (slide) {
      setHidden(slide, false);
    });
  }

  function applyAll() {
    document.querySelectorAll(SELECTOR).forEach(offsetOne);
  }

  // Rows can call this straight after they start, so they never show
  // unshifted first.
  window.MagnumCarouselBleed = { apply: offsetOne };

  function start() {
    // Other rows are set up by other scripts on ready/load, so check again.
    applyAll();
    setTimeout(applyAll, 400);

    // Re-shift on the very next frame of a resize, not after a pause, so the
    // row doesn't sit in the wrong place and then jump.
    var pending = false;
    window.addEventListener('resize', function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        applyAll();
      });
    });
    window.addEventListener('load', applyAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
